import React, { useState } from 'react';

const IS_DEV_BUILD = false;

/**
 * Přihlašovací obrazovka.
 * passwordSet === false  -> ještě nikdy nebylo nastaveno heslo, zadané heslo se uloží jako nové.
 * passwordSet === true   -> heslo už existuje, zadané se jen ověří.
 */
export default function Login({ passwordSet, onSubmit, onDevLogin, submitting, error }) {
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!password || submitting) return;
    onSubmit(password);
  };

  return (
    <div className="login">
      <form className="login__card" onSubmit={handleSubmit}>
        <span className="header__eyebrow">HUGOKNIVES</span>
        <h1 className="login__title">
          {passwordSet ? 'Přihlásit se' : 'Nastav přístupové heslo'}
        </h1>
        <p className="login__hint">
          {passwordSet
            ? 'Zadej heslo administrace webu hugoknives.cz.'
            : 'Ještě tu nikdo nebyl. Zvol si heslo — od teď bude sloužit k přihlášení.'}
        </p>

        <input
          type="password"
          className="login__input"
          placeholder="Heslo"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoFocus
          minLength={4}
          required
        />

        {error && <p className="login__error">{error}</p>}

        <button className="btn login__submit" type="submit" disabled={submitting}>
          {submitting ? 'Ověřuji…' : passwordSet ? 'Přihlásit' : 'Nastavit heslo a pokračovat'}
        </button>

        {IS_DEV_BUILD && (
          <button
            type="button"
            className="btn btn--dev login__dev"
            onClick={onDevLogin}
            disabled={submitting}
          >
            ⚠ Přihlásit bez hesla (jen dev)
          </button>
        )}
      </form>
    </div>
  );
}
